<template>
  <div
    class="relative w-full h-full overflow-y-auto dark:bg-dark-box-background"
    @mouseenter="hover_active = true"
    @mouseleave="hover_active = false">
    <TextInput
      :disabled="editing_disabled"
      :no-border="true"
      name="note_title"
      :value="new_label"
      :is-box-background="true"
      type="text"
      :placeholder="$t('Title')"
      :input-classes="`rounded-md appearance-none block w-full px-3 py-2  placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light text-lg`"
      @input="
        $utils.debounce(() => {
          new_label = $event.target.value
        }, 800)
      " />

    <div v-if="!fetched_all_attachments" class="text-common-grey">
      {{ $t("Loading...") }}
    </div>
    <div v-if="fetched_all_attachments" class="relative w-full h-[calcl(100%-46px)] mb-2" :class="[{ 'pointer-events-none': loading }]">
      <AttachmentsField v-model="new_attachments" :disabled="editing_disabled" overwrite-label="Assets" class="mt-4 mb-6" />
    </div>

    <div
      v-if="$route.name == 'CompanyProfile' || $route.name == 'ObjectProfile'"
      class="absolute z-50 text-xs cursor-pointer bottom-1 right-2 text-common-grey has-tooltip">
      <Info class="w-4 h-4 text-common-grey" />
      <span
        class="inline-flex items-center gap-2 px-2 py-1 -mt-10 text-xs font-medium rounded-md tooltip -ml-28 whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
        {{ $t("showing on") }} {{ typeof label == "object" ? $t("this page") : $t("all pages") }}</span>
    </div>
    <!-- <div class="mt-3 mbn-2" v-html="note.description" /> -->
  </div>
</template>

<script>
import AttachmentsField from "@/components/shared/form-inputs/AttachmentsField.vue"
import TextInput from "@/components/shared/TextInput.vue"
import dataService from "@/services/data.service"
import { Info } from "lucide-vue-next"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: { AttachmentsField, TextInput, Info },
  inject: ["canUserEditLayout"],
  props: {
    label: null,
    connectTo: null,
    linked_to: null,
    recordId: null,
    attachments: {
      type: Array,
      default: () => []
    },
    id: null
  },
  emits: [],

  data() {
    return {
      new_attachments: [],
      fetched_all_attachments: false,
      dont_trigger: false,
      loading: false,
      record_id: null,
      new_label: "",
      hover_active: false
    }
  },

  computed: {
    editing_disabled() {
      let editing_disabled_calc = false
      if (this.$route.name == "WorkspaceItem" && this.$store.state.ui.workspace_user_access_scope == "read") {
        editing_disabled_calc = true
      }

      if (this.$route.name == "Dashboard" && this.$route.params.page) {
        const current_template = this.$store.state.portfolio.shared_layouts.find((l) => l.id == this.$route.params.page)
        if (!this.canUserEditLayout(this.$store.state.auth.user, current_template)) {
          editing_disabled_calc = true
        }
      }

      return editing_disabled_calc
    }
  },

  watch: {
    "$store.state.ui.currentCompany": {
      deep: true,
      handler() {
        if (this.$store.state.ui.currentCompany && !this.dont_trigger) {
          this.init()
        }
      }
    },
    recordId() {
      this.init()
    },
    label() {
      this.init()
    },
    attachments: {
      deep: true,
      handler() {
        if (
          !this.$utils.isEqual(this.$utils.clone(this.attachments), this.$utils.clone(this.new_attachments)) &&
          this.recordId == "this_page"
        ) {
          this.init()
        }
      }
    },

    new_attachments: {
      deep: true,
      handler() {
        if (!this.dont_trigger) {
          this.updateAssetsComponent()
        }
      }
    },
    new_label: {
      handler() {
        if (!this.dont_trigger) {
          this.updateAssetsComponent()
        }
      }
    }
  },

  created() {
    this.new_label = this.label
    this.init()
  },
  activated() {
    this.init()
  },

  methods: {
    init() {
      this.fetched_all_attachments = false
      this.dont_trigger = true
      if (this.linked_to != "this_page") {
        if (
          this.linked_to == "this_record" ||
          (this.linked_to == "specific_record" && this.recordId == this.$store.state.ui.currentCompany?.id)
        ) {
          if (this.$store.state.ui.currentCompany?.id && this.$store.state.ui.currentCompany["attachments"]) {
            this.record_id = this.$route.params.cid
            if (this.$store.state.ui.currentCompany.attachments?.length) {
              dataService.getAttachmentsByIds(this.$store.state.ui.currentCompany.attachments.map((id) => id).join(",")).then((res) => {
                this.new_attachments = res.data.results
                this.fetched_all_attachments = true
                this.dont_trigger = false
              })
            } else {
              //this.new_attachments = []
              this.fetched_all_attachments = true
              this.dont_trigger = false
            }
          } else {
            this.fetched_all_attachments = true
            this.dont_trigger = false
          }
        } else {
          this.record_id = this.recordId
          this.$store
            .dispatch("data/getRecord", this.recordId)
            .then((res) => {
              if (res.data.attachments?.length) {
                dataService.getAttachmentsByIds(res.data.attachments.map((id) => id).join(",")).then((res) => {
                  this.new_attachments = res.data.results
                  this.fetched_all_attachments = true
                  this.dont_trigger = false
                })
              } else {
                //this.new_attachments = []
                this.fetched_all_attachments = true
                this.dont_trigger = false
              }
            })
            .catch(() => {
              this.new_attachments = []
              this.fetched_all_attachments = true
              this.dont_trigger = false
            })
        }
      } else {
        this.record_id = "this_page"
        if (this.attachments && this.attachments.length) {
          dataService.getAttachmentsByIds(this.attachments.map((id) => id).join(",")).then((res) => {
            this.new_attachments = res.data.results
            this.fetched_all_attachments = true
            this.dont_trigger = true
            setTimeout(() => {
              this.dont_trigger = false
            }, 400)
          })
        } else {
          this.fetched_all_attachments = true
          setTimeout(() => {
            this.dont_trigger = false
          }, 400)
        }
      }
    },

    updateAssetsComponent() {
      if (this.record_id) {
        this.loading = true
        setTimeout(() => {
          this.loading = false
        }, 1200)
        this.$emitter.emit(ALL_EMITTERS.UPDATE_ASSETS_INSTANCE, {
          label: this.new_label,
          attachments: this.new_attachments,
          id: this.id,
          recordId: this.record_id,
          linked_to: this.linked_to,
          component_type: "assets",
          connectTo: this.connectTo
        })
      }
    }
  }
}
</script>
